var googleMapMarker;

function GoggleMapInit() {

    var googleMap = $('.google-map');

    var mapElement = googleMap[0];

    var defaultLngLat = { lng: googleMap.data('longitude'), lat: googleMap.data('latitude') };
    var defaultZoom = googleMap.data('zoom');

    var mapProp = {
        center: new google.maps.LatLng(defaultLngLat),
        zoom: defaultZoom,
        panControl: false,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        overviewMapControl: false,
        rotateControl: true,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    map = new google.maps.Map(mapElement, mapProp);

    map.mapTypes.set('map_style', GoogleMapStyle());
    map.setMapTypeId('map_style');

    if (defaultZoom > 5) {
        googleMapMarker = new google.maps.Marker({
            position: new google.maps.LatLng(defaultLngLat),
            icon: '/images/map-marker.png'
        });

        googleMapMarker.setMap(map);
    }
}

function SetMapMarker(officeElement) {
    if (officeElement == undefined || !officeElement.data('longitude') || !officeElement.data('latitude')) {
        officeElement = $('.google-map');
        googleMapMarker.setMap(null);
    }

    var lngLat = { lng: officeElement.data('longitude'), lat: officeElement.data('latitude') };
    var zoom = officeElement.data('zoom');

    if (zoom > 5) {
        googleMapMarker = new google.maps.Marker({
            position: new google.maps.LatLng(lngLat),
            icon: '/images/map-marker.png'
        });

        googleMapMarker.setMap(map);
    } 

    map.setCenter(lngLat);
    map.setZoom(zoom);
}